import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_68nq5v4hum: FaireBrandEntity = {
  token: "b_68nq5v4hum",
  type: "brand",
  name: "Forever11",
  avatarUrl:
    "https://cdn.faire.com/fastly/85688b3e6f44e106627d47c980fc9e972feff891d63442e164efe1ebc720ab01.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/afd8ffb0f2a5caf880162ce0a9523ff173b7bfc34fbad691994386d2d41ca600.png",
  logoUrl:
    "https://cdn.faire.com/fastly/85688b3e6f44e106627d47c980fc9e972feff891d63442e164efe1ebc720ab01.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/afd8ffb0f2a5caf880162ce0a9523ff173b7bfc34fbad691994386d2d41ca600.png",
  location: "Elk Grove Village, IL, USA",
  minimumOrderDollars: 0,
  rating: 4.7,
  reviewCount: 31,
  isInsider: true,
  description:
    'Hello Everyone! My name is Lina and I am the founder of "Forever11" brand. I have been working with women\'s clothing for more than 7 years and in 2023 I decided to create my own clothing brand. Our products are made of the best materials and we are proud to be a part of the Faire and present our products here.',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:57.418Z",
    importedBy: "entity-db-cli",
  },
};
